import { Link, useSearchParams } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { useAuth } from '@/hooks/useAuth'
import { useInstitution } from '@/contexts/InstitutionContext'
import { RoletaPanel } from './RoletaPanel'
import styles from './CampanhasPage.module.css'

export function RoletaTab() {
  const [searchParams] = useSearchParams()
  const campaignIdParam = searchParams.get('id')
  const campaignId = campaignIdParam ? parseInt(campaignIdParam, 10) : null
  const { guard, token } = useAuth()
  const { institutionId } = useInstitution()

  if (campaignId == null || Number.isNaN(campaignId)) {
    return (
      <div className={styles.page}>
        <div className={styles.panelCard}>
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <Icon icon="mdi:circle-slice-8" />
            </div>
            <h4>Selecione uma campanha</h4>
            <p>
              Escolha uma campanha na listagem para configurar a roleta (config, prêmios e prêmios
              distribuídos).
            </p>
            <Link to="/campanhas" className={styles.primaryButton}>
              Ir para Campanhas
            </Link>
          </div>
        </div>
      </div>
    )
  }

  if (guard === 'admin' && institutionId === null) {
    return (
      <div className={styles.page}>
        <div className={styles.panelCard}>
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <Icon icon="mdi:office-building-outline" />
            </div>
            <h4>Selecione uma instituição</h4>
            <p>Selecione uma instituição no menu acima para configurar a roleta.</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <RoletaPanel campaignId={campaignId} token={token} />
    </div>
  )
}
